export default "__VITE_PUBLIC_ASSET__69902248__"